import { Box } from '@mui/material'
import {
  useGetInventoryStockPolicy,
  useUpdateInventoryStockPolicy,
  useUploadInventoryStockPolicy,
} from './SystemOfRecords.data'
import { InventoryStockPolicyTable } from './InventoryStockPolicy.MUITable'
import { InventoryStockPolicyRowType } from './SystemOfRecords.types'
import { toast } from 'react-hot-toast'

export const InventoryStockPolicyView = () => {
  const { data: inventoryData, isLoading } = useGetInventoryStockPolicy()

  const onUpdateSuccess = () => {
    toast.success('Inventory stock policy updated successfully')
  }
  const onUpdateFailure = () => {
    toast.error('Failed to update inventory stock policy')
  }

  const { mutate: saveInventoryStockPolicy, isLoading: isSaving } =
    useUpdateInventoryStockPolicy(onUpdateSuccess, onUpdateFailure)

  const updateTableData = (
    changedRows: Record<number, InventoryStockPolicyRowType>
  ) => {
    saveInventoryStockPolicy(changedRows)
  }

  const onUploadSuccess = () => {
    toast.success('Inventory stock policy uploaded successfully')
  }
  const onUploadFailure = () => {
    toast.error('Failed to upload inventory stock policy')
  }
  const { mutate: uploadInventoryStockPolicy, isLoading: isUploading } =
    useUploadInventoryStockPolicy(onUploadSuccess, onUploadFailure)

  return (
    <Box
      padding={0}
      marginTop={2}
      sx={{ height: 'calc(100vh - 200px)', minHeight: 0 }}
    >
      <InventoryStockPolicyTable
        data={inventoryData?.data ?? []}
        isLoading={isLoading}
        updateTableData={updateTableData}
        businessDrivenStockPolicy={
          inventoryData?.businessDrivenStockPolicy ?? []
        }
        locationCode={inventoryData?.locationCode ?? ''}
        skuCode={inventoryData?.skuCode ?? ''}
        unitOfMeasureCode={inventoryData?.unitOfMeasureCode ?? ''}
        isUploading={isUploading}
        uploadInventoryStockPolicy={uploadInventoryStockPolicy}
        isSaving={isSaving}
      />
    </Box>
  )
}
